/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/

import React from "react";

export const HeroiconsMiniHome = ({ className }) => {
  return (
    <svg
      className={`heroicons-mini-home ${className}`}
      fill="none"
      height="20"
      viewBox="0 0 20 20"
      width="20"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        className="path"
        clipRule="evenodd"
        d="M9.29289 2.29289C9.68342 1.90237 10.3166 1.90237 10.7071 2.29289L17.7071 9.29289C17.9931 9.57889 18.0787 10.009 17.9239 10.3827C17.7691 10.7564 17.4045 11 17 11H16V17C16 17.5523 15.5523 18 15 18H13C12.4477 18 12 17.5523 12 17V14C12 13.4477 11.5523 13 11 13H9C8.44771 13 8 13.4477 8 14V17C8 17.5523 7.55228 18 7 18H5C4.44771 18 4 17.5523 4 17V11H3C2.59554 11 2.2309 10.7564 2.07612 10.3827C1.92134 10.009 2.00689 9.57889 2.29289 9.29289L9.29289 2.29289Z"
        fill="#7041F1"
        fillRule="evenodd"
      />
    </svg>
  );
};
